import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["direction"];
import React from 'react';
import PropTypes from 'prop-types';
var DIRECTIONS = {
  up: -90,
  right: 0,
  down: 90,
  left: 180
};

var withDirection = function withDirection(Icon) {
  var RotatedIcon = function RotatedIcon(_ref) {
    var direction = _ref.direction,
        props = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement(Icon, _extends({
      style: {
        transform: "rotate(".concat(DIRECTIONS[direction], "deg)")
      }
    }, props));
  };

  RotatedIcon.propTypes = {
    direction: PropTypes.oneOf(Object.keys(DIRECTIONS))
  };
  RotatedIcon.defaultProps = {
    direction: 'right'
  };
  RotatedIcon.isIcon = true;
  return RotatedIcon;
};

export default withDirection;